"use client";

const FeatureCircle = ({ bgColor, icon: Icon, heading, description }) => {
  return (
    <div
      className={`flex flex-col items-center justify-center mx-auto my-2 p-4 rounded-full text-center`}
      style={{
        backgroundColor: bgColor,
        width: "250px",
        height: "250px",
      }}
    >
      {/* Responsive sizes */}
      <div className="flex flex-col items-center justify-center text-center w-full h-full">
        <Icon className="text-white text-2xl sm:text-3xl mb-2" />
        <h3 className="text-white text-md sm:text-lg mt-2">{heading}</h3>
        <p className="text-white text-xs sm:text-sm mt-1 px-4 line-clamp-3">
          {description}
        </p>
      </div>
    </div>
  );
};

export default FeatureCircle;
